var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),(_vm.time_warning)?_c('p',[_vm._v("Esto puede tardar tiempo")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }